import {
    Box,
    Container,
    Figure,
    Link,
    LinkList,
    StyledHtml,
    Text,
} from "@postenbring/hedwig-react";
import { Breadcrumbs } from "../../shared/breadcrumbs/breadcrumbs";
import { Accordion } from "../../shared/accordion/accordion";
import { ButtonList, Button } from "@postenbring/hedwig-react";
import { Cards } from "../cards/cards";
import "./webarticle.scss";

export const Webarticle = ({ breadcrumbs, content, dateField, labels, relatedContents }) => (
    <>
        <Container>
            {content.displayBreadcrumbs && <Breadcrumbs crumbs={breadcrumbs}></Breadcrumbs>}

            {content.backButton && (
                <Link href={content.backButtonUrl} target={content.backButtonTarget}>
                    {content.backButtonText}
                </Link>
            )}

            <div className="webarticle-preface hds-mt-24-32">
                <Text variant="h1" className="hds-mb-48-64">
                    {content.heading}
                </Text>
                <Text variant="h3" as="p" className="hds-mb-48-64">
                    {content.preface}
                </Text>
            </div>

            {(!content.hideMainImage || dateField) && (
                <div className="hds-mb-48-64">
                    {!content.hideMainImage && content.figure && (
                        <Figure>
                            <picture>
                                <source
                                    media="(max-width: 939px)"
                                    data-th-srcset={content.figure.smallImage}
                                />
                                <source
                                    media="(min-width: 940px)"
                                    data-th-srcset={content.figure.largeImage}
                                />
                                <img src={content.figure.largeImage} alt={content.imageAltText} />
                            </picture>
                        </Figure>
                    )}
                    {dateField && (
                        <div className="hds-mt-20-24 ">
                            <>
                                <Text variant="technical">
                                    {labels.publishedDatedLabel} {content.publishDate} |{" "}
                                    {labels.modifiedDateLabel} {content.modifiedDate}
                                </Text>
                                {content.showWrittenBy && (
                                    <Text variant="technical">
                                        {labels.writtenBy} {content.writtenBy}
                                    </Text>
                                )}
                            </>
                        </div>
                    )}
                </div>
            )}
        </Container>
        <Container className="hds-mb-48-64">
            <div className="webarticle-content-block">
                {content.blocks && (
                    <>
                        {content.blocks.map((item, index) => (
                            <>
                                <StyledHtml
                                    dangerouslySetInnerHTML={{ __html: item.content }}
                                ></StyledHtml>
                                {item.linkList && (
                                    <div>
                                        <Text variant="h3" as="h2" className="hds-mb-16-20">
                                            {item.linkList.linkListTitle}
                                        </Text>
                                        <LinkList>
                                            {item.linkList.list.map((linkItem, linkIndex) => (
                                                <li key={linkIndex}>
                                                    <Link
                                                        href={linkItem.url}
                                                        target={
                                                            linkItem.newTab ? "_blank" : "_self"
                                                        }
                                                    >
                                                        {linkItem.linkText}
                                                    </Link>
                                                </li>
                                            ))}
                                        </LinkList>
                                    </div>
                                )}

                                {/* Previously know as summary box, now cta  */}
                                {item.summaryBox && (
                                    <Box variant="white">
                                        {item.summaryBox.boxTitle && (
                                            <Text variant="h2" as="h2" className="hds-mb-20-24">
                                                {item.summaryBox.boxTitle}
                                            </Text>
                                        )}
                                        <StyledHtml
                                            dangerouslySetInnerHTML={{
                                                __html: item.summaryBox.boxBody,
                                            }}
                                        ></StyledHtml>
                                        {item.summaryBox.buttons && (
                                            <ButtonList variant="default" className="hds-mt-24-32">
                                                {item.summaryBox.buttons.map((button, index) => (
                                                    <Button
                                                        asChild
                                                        variant={
                                                            index === 0 ? "primary" : "secondary"
                                                        }
                                                        fullWidth={false}
                                                        size="large"
                                                        key={index}
                                                    >
                                                        <a
                                                            href={button.url}
                                                            target={button.buttonTarget}
                                                        >
                                                            {button.linkText}
                                                        </a>
                                                    </Button>
                                                ))}
                                            </ButtonList>
                                        )}
                                    </Box>
                                )}
                                {item.faq && (
                                    <div>
                                        <Text variant="h2" className="hds-mb-40-48">
                                            {item.faq.title}
                                        </Text>
                                        <Text variant="body">{item.faq.preface}</Text>
                                        <Accordion accordionItems={item.faq.list} />
                                    </div>
                                )}

                                {/* Previously know as highlighted text box, now summary */}
                                {item.highlightedTextBox && (
                                    <Box>
                                        <Text variant="body-title" as="h2" className="hds-mb-4-8">
                                            {item.highlightedTextBox.boxTitle}
                                        </Text>
                                        <StyledHtml
                                            dangerouslySetInnerHTML={{
                                                __html: item.highlightedTextBox.boxBody,
                                            }}
                                        ></StyledHtml>
                                    </Box>
                                )}
                            </>
                        ))}
                    </>
                )}
            </div>
        </Container>
        {relatedContents && (
            <Container className="hds-mb-48-64">
                <Text variant="h2" as="h2" className="hds-mb-16-20">
                    {relatedContents.title}
                </Text>
                <Cards cards={relatedContents.data} span={relatedContents.span}></Cards>
            </Container>
        )}
    </>
);
